import * as React from 'react';
import { Editor, EditorState, convertToRaw, convertFromRaw, SelectionState, RichUtils, ContentBlock } from 'draft-js';
import { BasePureComponent } from './BaseComponent';
import 'draft-js/dist/Draft.css';
import * as Dati from '../Dati';

interface EditorProps extends Dati.IBaseProps {
    description: string,
    visibility: string,
}

interface IEditorState {
    editorState: EditorState,
    internalUpdate: number,
    headerValue: string,
}

export class TextEditor extends BasePureComponent<EditorProps, IEditorState> {

    constructor(props: any) {
        super(props);
        this.state = { editorState: EditorState.createEmpty(), internalUpdate: 0, headerValue: "" };
        this.onInlineStyleChange = this.onInlineStyleChange.bind(this);
        this.onBlockTypeChange = this.onBlockTypeChange.bind(this);

    }

    handleChange(e: EditorState) {
        this.setState({ editorState: e, internalUpdate: this.state.internalUpdate + 1 }, () => this.props.OnChange(this.props.Name, JSON.stringify(convertToRaw(e.getCurrentContent()))));
        //let draft_dom = ReactDOM.findDOMNode(this);
        //if (draft_dom != undefined && draft_dom instanceof HTMLElement) {
        //    let blocco = draft_dom.querySelector("div[data-contents]");
        //    if (blocco != undefined) {
        //        this.props.OnChange(this.props.Name, "<style>.align-right div {text-align: right;} .align-center div {text-align: center;} .align-left div {text-align: left;} .align-justify div {text-align: justify;}</style>" + blocco.innerHTML);
        //    }
        //}
    }

    componentWillReceiveProps(nextProps: EditorProps) {
        if (nextProps.description != this.props.description && this.state.internalUpdate == 0)
            this.setState({ editorState: EditorState.createWithContent(convertFromRaw(JSON.parse(nextProps.description))) })
    }

    handleKeyCommand = (command: string) => {
        const newState = RichUtils.handleKeyCommand(this.state.editorState, command)
        if (newState) {
            this.handleChange(newState);
            return 'handled';
        }
        return 'not-handled';
    }

    onTab = (e: React.KeyboardEvent) => {
        const maxDepth = 4;
        this.handleChange(RichUtils.onTab(e, this.state.editorState, maxDepth));
    }

    onInlineStyleChange(e: React.MouseEvent, buttonStyle: string) {
        e.preventDefault();
        this.handleChange(RichUtils.toggleInlineStyle(this.state.editorState, buttonStyle));
    }

    onBlockTypeChange(e: React.MouseEvent | React.ChangeEvent<HTMLSelectElement>, buttonType: string) {
        e.preventDefault();
        this.handleChange(RichUtils.toggleBlockType(this.state.editorState, buttonType));
    }

    onHeaderBlockChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
        this.setState({ headerValue: e.target.value }, () => this.onBlockTypeChange(e, this.state.headerValue))
    }


    getBlockStyle = (block: ContentBlock): string => {
        switch (block.getType()) {
            case "blockquote":
                return "RichEditor-blockquote";
            case "left":
                return "align-left";
            case "center":
                return "align-center";
            case "right":
                return "align-right";
            case "justify":
                return "align-justify";
            default:
                return "";
        }
    }

    addActiveClass = (inlineStyle: boolean) => {
        let buttonClass = "editor-styleButton";
        inlineStyle ? buttonClass += " editor-activeButton" : buttonClass;
        return buttonClass;
    }

    render() {
        const { editorState } = this.state;
        const currentStyle = editorState.getCurrentInlineStyle();
        const selection = editorState.getSelection();
        const blockType = editorState.getCurrentContent().getBlockForKey(selection.getStartKey()).getType();

        return (
            <div style={{ border: '1px solid #ccc' }} >
                <div className="inner-editor">
                    <div className={`editor-header ${this.props.visibility}`} >

                        <div className='btn btn-light header-dropdown'>
                            <select value={blockType} id="headers-select" className="form-control" onChange={this.onHeaderBlockChange}>
                                <option value="" >Header Levels</option>
                                {HEADERS.map(header => (
                                    <option key={header.label} className={`header ${header.headerStyle}`} value={header.style}>{header.label}</option>
                                ))}
                            </select>
                        </div>

                        <div className="inline-styles">
                            {INLINE_STYLES.map(style => (
                                <button key={style.label} className={`btn ${this.addActiveClass(currentStyle.has(style.style))}`} onClick={(e) => this.onInlineStyleChange(e, style.style)} ><i className={`fa ${style.icon}`}></i></button>
                            ))}
                        </div>

                        <div className="block-styles">
                            {BLOCK_TYPES.map(block => (
                                <button key={block.label} className={`btn ${this.addActiveClass(block.style === blockType)}`} onClick={(e) => this.onBlockTypeChange(e, block.style)} ><i className={`fa ${block.icon}`}></i></button>
                            ))}
                        </div>

                    </div>

                    <Editor
                        editorState={this.state.editorState}
                        blockStyleFn={this.getBlockStyle}
                        onChange={(e: EditorState) => this.handleChange(e)}
                        handleKeyCommand={this.handleKeyCommand}
                        customStyleMap={styleMap}
                        stripPastedStyles={true}
                        onTab={this.onTab}
                        readOnly={this.props.visibility ? true : false}
                    />
                </div>
            </div>
        );
    }
}


export const styleMap = {
    CODE: {
        backgroundColor: "rgba(0, 0, 0, 0.05)",
        fontFamily: '"Inconsolata", "Menlo", "Consolas", monospace',
        fontSize: 16,
        padding: 2
    },
    HIGHLIGHT: {
        backgroundColor: 'yellow',
    },
    STRIKETHROUGH: {
        textDecoration: 'line-through',
    },
};

export const INLINE_STYLES = [
    { label: "old", style: "BOLD", icon: "fa-bold" },
    { label: "Italic", style: "ITALIC", icon: "fa-italic" },
    { label: "Underline", style: "UNDERLINE", icon: "fa-underline" },
    { label: 'Strikethrough', style: 'STRIKETHROUGH', icon: "fa-strikethrough" },
    { label: "Monospace", style: "CODE", icon: "fa-quote-right" },
    { label: 'Highlight', style: 'HIGHLIGHT', icon: "fa-highlighter" },
];

export const HEADERS = [
    { label: "Header 1", style: "header-one", headerStyle: "header1" },
    { label: "Header 2", style: "header-two", headerStyle: "header2" },
    { label: "Header 3", style: "header-three", headerStyle: "header3" },
    { label: "Header 4", style: "header-four", headerStyle: "header4" },
    { label: "Header 5", style: "header-five", headerStyle: "header5" },
    { label: "Header 6", style: "header-six", headerStyle: "header6" },
    { label: "Regular", style: "paragraph", headerStyle: "paragraph" },
]

export const BLOCK_TYPES = [
    { label: "UL", style: "unordered-list-item", icon: "fa-list-ul" },
    { label: "OL", style: "ordered-list-item", icon: "fa-list-ol" },
    { label: "Align left", style: "left", icon: "fa-align-left" },
    { label: "Align center", style: "center", icon: "fa-align-center" },
    { label: "Align right", style: "right", icon: "fa-align-right" },
    { label: "Justify content", style: "justify", icon: "fa-align-justify" },
];











// WEBPACK FOOTER //
// ./src/components/TextEditor.tsx